import { RefreshCw } from 'lucide-react'
import { toast } from '../hooks/use-toast'
import { ToastAction } from './ui/toast'
import { useVersionCheck } from '../hooks/useVersionCheck'

// Radix closes a toast on a timer, and setTimeout coerces Infinity to 0 (the
// toast would vanish instantly), so "stays until dismissed" is spelled as the
// longest delay setTimeout accepts.
const NEVER_AUTO_DISMISS_MS = 2 ** 31 - 1

/**
 * Renders nothing; watches for a newer deployed build and offers a reload.
 */
export default function VersionRefreshWatcher(): null {
  useVersionCheck(() => {
    toast({
      title: 'A new version is available',
      description: 'Refresh to load the latest changes.',
      duration: NEVER_AUTO_DISMISS_MS,
      action: (
        <ToastAction altText="Refresh the page" onClick={() => window.location.reload()}>
          <RefreshCw className="h-4 w-4 mr-2 text-green-600" />
          Refresh
        </ToastAction>
      ),
    })
  })

  return null
}
